/* eslint-disable arrow-body-style */
import React, { useContext, useRef } from "react";
import PropTypes from "prop-types";
import MegaItems from 'gatsby-core-theme/src/components/atoms/menu/mega-items';
import Items from 'gatsby-core-theme/src/components/atoms/menu/items';

import MenuIcon from "~atoms/menu/menu-icon";
import { NavigationContext } from "~organisms/navigation/navigationContext";

import styles from "./menu.module.scss";
import keygen from "~helpers/keygen";
import { getMenuObj } from "~helpers/menu";
import { toggleScroll } from "~helpers/scroll";

const Menu = ({
  pageContext,
  section,
  menu = "menu",
  gtmClass = "",
  customStyles,
  orientation = "horizontal",
  mobileAnimation = "collapseFull",
  stopScrollOnOpen = true,
  canOpenAllSubMenus = true,
  enableMegaMenu = false
}) => {
  let menuObject;
  
  const currentPagePath = pageContext?.page?.path;

  const menuListRef = useRef(React.createRef());
  const toplistModule = section?.modules?.find(
    (module) => module.name === "top_list"
  );

  const { setShowSearch, setShowMenu, showMenu, showSearch } =
    useContext(NavigationContext);

  if (section?.modules) {
    menuObject = getMenuObj(section.modules, menu);
  }

  const menuListClasses = `${styles.menuList} ${
    mobileAnimation ? styles[mobileAnimation] : ""
  } ${orientation ? styles[orientation] : ""}`;

  function handleMenuIconClick() {
    if (stopScrollOnOpen) {
      toggleScroll("menu");
    }

    setShowMenu(!showMenu);

    if (showSearch) {
      setShowSearch(false);
      toggleScroll("search");
    }
  }

  return (
    <div className={styles.menuContainer || ""}>
      <MenuIcon
        onClick={() => handleMenuIconClick()}
        gtmClass="main-menu-gtm"
      />
      <ul
        ref={menuListRef}
        className={`${menuListClasses || ""} ${
          showMenu && (styles.show || "")
        } ${styles[customStyles] || ""}`}
        role="menu"
      >
        {menuObject &&
          menuObject?.children?.map((child) => {
            const level = 1;
            return (
              enableMegaMenu ? (
                <MegaItems
                  toplist={toplistModule}
                  menuListRef={menuListRef}
                  gtmClass={gtmClass}
                  key={keygen()}
                  item={child}
                  canOpenAllSubMenus={canOpenAllSubMenus}
                  level={level}
                />
              ) : (
                <Items
                  currentPage={currentPagePath}
                  toplist={toplistModule}
                  menuListRef={menuListRef}
                  gtmClass={gtmClass}
                  key={keygen()}
                  item={child}
                  canOpenAllSubMenus={canOpenAllSubMenus}
                  level={level}
                />
              )
            );
          })}
      </ul>
    </div>
  );
};

Menu.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      path: PropTypes.string
    })
  }),
  section: PropTypes.shape({
    modules: PropTypes.arrayOf(
      PropTypes.shape({
        menu_short_code: PropTypes.string,
        children: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            value: PropTypes.string,
          })
        ),
      })
    ),
  }).isRequired,
  menu: PropTypes.string,
  gtmClass: PropTypes.string,
  customStyles: PropTypes.shape({}),
  orientation: PropTypes.oneOf(["horizontal"]),
  mobileAnimation: PropTypes.oneOf([
    "collapseFull",
    "collapse",
    "slideLeft",
    "slideTop",
  ]),
  stopScrollOnOpen: PropTypes.bool,
  canOpenAllSubMenus: PropTypes.bool,
  enableMegaMenu: PropTypes.bool,
};

export default Menu;
